// MUST be first: strips the `#impersonate=...` fragment and seeds the session
// before the router module (created at import time) captures window.location.
import "@/utils/auth/bootstrapImpersonation";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-quill/dist/quill.snow.css";
import "nprogress/nprogress.css";
import { ApolloProvider } from "@apollo/client";
import StyledEngineProvider from "@material-ui/core/StyledEngineProvider";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import { initSentry } from "@/lib/sentry";
import { migrateLegacyScopeIds, reloadForStaleChunkOnce } from "@/utils/common";
import client from "src/utils/apolloClient";

import App from "./App";
import { SettingsProvider } from "./contexts/SettingsContext";

initSentry();

// One-time public-id migration: drop legacy numeric platform/org ids from
// localStorage before any provider reads them. Must run before `root.render`.
migrateLegacyScopeIds();

// Safety net for chunks that fail to load outside a route error boundary (e.g.
// the auth layout loaded before the dashboard tree mounts). Vite fires this when
// a dynamically imported module can't be fetched — usually a stale chunk after a
// deploy. Reload once (throttled) to pull the freshly deployed assets.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadForStaleChunkOnce();
});

const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  // <StrictMode>
  <HelmetProvider>
    <StyledEngineProvider injectFirst>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider>
          <QueryClientProvider client={queryClient}>
            <ApolloProvider client={client}>
              <App />
            </ApolloProvider>
          </QueryClientProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </StyledEngineProvider>
  </HelmetProvider>
  // </StrictMode>,
);
